import styled from "styled-components";

export const SearchMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
`;
export const GoBackContainer = styled.div`
  width: 100%;
  height: 50px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.2rem 0.6rem;
  height: 220px;
`;
export const Label = styled.label`
  margin-bottom: 0.4rem;
`;
export const OverTable = styled.div`
  padding: 0 0.6rem;
  height: 50px;
`;
export const PillsContainer = styled.div`
  align-self: stretch;
  flex: 1;
`;
export const TabContainer = styled.div`
  height: 100%;
`;

export const styles = (theme) => ({
  noPaddingTop: {
    paddingTop: "0px",
  },
});
